module.exports = __webpack_public_path__ + "static/pine-e02154d640682a501663c1272f1b9343.jpg";